export default __webpack_public_path__ + "static/media/martin_adler.2ec76d1b.png";